'use strict';

var chunkHPRUU6IH_js = require('../chunk-HPRUU6IH.js');
require('../chunk-TI4S3S4J.js');
require('../chunk-HUKGHOBJ.js');
require('../chunk-S7FZ7BAB.js');
require('../chunk-M632V57T.js');



Object.defineProperty(exports, "Heading", {
	enumerable: true,
	get: function () { return chunkHPRUU6IH_js.a; }
});
